export const Geography = {
    // Decimal degrees constants

    /**
     * Minimum latitude for the United States and territories (inclusive).
     */
    latitudeUnitedStatesAndTerritoriesMinimum: -10,

    /**
     * Maximum latitude for the United States and territories (inclusive).
     */
    latitudeUnitedStatesAndTerritoriesMaximum: 73,

    /**
     * Minimum longitude for the United States and territories (inclusive).
     */
    longitudeUnitedStatesAndTerritoriesMinimum: -175,

    /**
     * Maximum longitude for the United States and territories (inclusive).
     */
    longitudeUnitedStatesAndTerritoriesMaximum: 150,

    // DMS constants
    latitudeLongitudeDegreesMinimum: 0,

    latitudeLongitudeMinutesMinimum: 0,
    latitudeLongitudeMinutesMaximum: 59,

    latitudeLongitudeSecondsMinimum: 0,
    latitudeLongitudeSecondsMaximum: 59.9,
} as const;
